import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DateTimePickerService {

  constructor(
    @Inject('DATE_TIME_PICKER_INPUT_DATE_TIME_FORMAT') private inputDatetimeFormat: string = 'dd/MM/yyyy HH:mm',
    @Inject('DATE_TIME_PICKER_SHOW_LABEL') private showLabel: boolean = true,
    @Inject('DATE_TIME_PICKER_OPEN_WHEN_FOCUS') private openWhenFocus: boolean = false,
    @Inject('DATE_TIME_PICKER_GO_NEXT_WHEN_SELECT') private goNextWhenSelect: boolean = false,
    @Inject('DATE_TIME_PICKER_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('DATE_TIME_PICKER_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('DATE_TIME_PICKER_SUBMITTED') private submitted: boolean = true,
  ) {
  }

  public getInputDatetimeFormat(): string {
    return this.inputDatetimeFormat;
  }
  public getShowLabel(): boolean {
    return this.showLabel;
  }
  public getOpenWhenFocus(): boolean {
    return this.openWhenFocus;
  }
  public getGoNextWhenSelect(): boolean {
    return this.goNextWhenSelect;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  
}